export default [
  {
    path: 'regional',
    redirect: { name: 'regionals' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'regionals',
        component: () => import('@pages/regionals/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Regional',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Regional',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'regionals-add',
        component: () => import('@pages/regionals/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Regional',
          navActiveLink:'regionals',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Regional',
              to: { name: 'regionals' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'regionals-edit',
        component: () => import('@pages/regionals/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Regional',
          navActiveLink:'regionals',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Regional',
              to: { name: 'regionals' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]